export enum InviteStatus {
  NOT_APPLIED = 0, // 未申请
  PENDING = 1, // 待审批
  APPROVED = 2, // 通过
  REJECTED = 3, // 拒绝
  JOINED = 4, // 已加入组织
  DISABLED = 5, // 邀请链接禁用
  EXPIRED = 6, // 过期
}

export enum CodeType {
  ORG = 1, // 组织邀请
  PROJECT = 2, // 项目邀请
}

// entrance = login(登录）/ bind（绑定）/register(注册）/ notify（修改）
export enum Entrance {
  LOGIN = "login",
  BIND = "bind",
  REGISTER = "register",
  NOTIFY = "notify",
}

/**
 * 验证码类型枚举
 * @enum {number}
 */
export enum VerifyCodeType {
  LOGIN = 1, // 登录验证
  CREATE_ORG = 2, // 创建组织
  APPLY_JOIN = 3, // 申请加入组织
  DESIGNATE_INVITE = 4, // 指定成员邀请
  BIND_PHONE = 5, // 绑定手机号
  VERIFY_IDENTIFIER = 6, // 验证身份
  UPDATE_IDENTIFIER = 7, // 更新身份信息
  RESET_PASSWORD = 8, // 重置密码
}

/**
 * 申请状态类型枚举
 */
export enum ApplyStatusType {
  NOT_APPLIED = 0, // 未申请
  PENDING = 1, // 申请中
  APPROVED = 2, // 已通过
  REJECTED = 3, // 已拒绝
  JOINED = 4, // 已加入组织
  INVALID = 5, // 邀请链接被禁用
  EXPIRED = 6, // 邀请链接已过期
  ALREADY_APPROVED = 7, // 申请已通过
  ALREADY_REJECTED = 8, // 申请已拒绝
  MEMBER_SEAT_LIMIT = 9, // 达到组织人数上限
  MEMBER_BOUND = 10, // 组织中已有相同的邮箱,请联系管理员解绑
  COPY_LINK_TO_BROWSER = 11, // 复制链接到浏览器打开
  APPLY_PENDING = 12, // 组织申请列表已有相同邮箱
  APPLY_LINK_EMPTY = 13, // 邀请链接不存在
}

/**
 * 申请状态文案映射
 */
export const ApplyStatusTypeText: Record<ApplyStatusType, string> = {
  [ApplyStatusType.NOT_APPLIED]: "未申请",
  [ApplyStatusType.PENDING]: "申请中",
  [ApplyStatusType.APPROVED]: "已通过",
  [ApplyStatusType.REJECTED]: "已拒绝",
  [ApplyStatusType.JOINED]: "已加入组织",
  [ApplyStatusType.INVALID]: "邀请链接被禁用",
  [ApplyStatusType.EXPIRED]: "该链接已失效，请联系组织管理员重新发送邀请",
  [ApplyStatusType.ALREADY_APPROVED]: "申请已通过",
  [ApplyStatusType.ALREADY_REJECTED]: "申请已拒绝",
  [ApplyStatusType.MEMBER_SEAT_LIMIT]: "组织成员已满，如需加入组织请联系组织管理员扩充成员数量上限",
  [ApplyStatusType.MEMBER_BOUND]: "组织内已有相同邮箱，请勿重复加入",
  [ApplyStatusType.COPY_LINK_TO_BROWSER]: "复制链接到浏览器打开",
  [ApplyStatusType.APPLY_PENDING]: "组织申请列表已有相同邮箱",
  [ApplyStatusType.APPLY_LINK_EMPTY]: "邀请链接不存在",
}

/**
 * 申请状态文案映射
 */
export const ApplyStatusTypeCode: Record<ApplyStatusType, string> = {
  [ApplyStatusType.NOT_APPLIED]: "NOT_APPLIED",
  [ApplyStatusType.PENDING]: "PENDING",
  [ApplyStatusType.APPROVED]: "APPROVED",
  [ApplyStatusType.REJECTED]: "REJECTED",
  [ApplyStatusType.JOINED]: "JOINED",
  [ApplyStatusType.INVALID]: "INVALID",
  [ApplyStatusType.EXPIRED]: "EXPIRED",
  [ApplyStatusType.ALREADY_APPROVED]: "ALREADY_APPROVED",
  [ApplyStatusType.ALREADY_REJECTED]: "ALREADY_REJECTED",
  [ApplyStatusType.MEMBER_SEAT_LIMIT]: "MEMBER_SEAT_LIMIT",
  [ApplyStatusType.MEMBER_BOUND]: "MEMBER_BOUND",
  [ApplyStatusType.COPY_LINK_TO_BROWSER]: "COPY_LINK_TO_BROWSER",
  [ApplyStatusType.APPLY_PENDING]: "APPLY_PENDING",
  [ApplyStatusType.APPLY_LINK_EMPTY]: "APPLY_LINK_EMPTY",
}

/**
 * 登录类型枚举
 */
export enum LoginTypeEnum {
  EMAIL = "email",
  SMS = "sms",
  FEISHU = "feishu",
}

/**
 * 登录步骤枚举
 */
export enum ShowTypeEnum {
  INIT = "init", // 初始状态
  VERIFICATION = "verification", // 验证码输入
  PASSWORD = "password", // 密码输入
  ORGANIZATION = "organization", // 组织选择
  NO_ORGANIZATION = "no-organization", // 无组织（创建/加入）
  JOIN_ORGANIZATION = "join-organization", // 加入组织
  INPUT_NAME = "input-name", // 输入姓名
  ORG_APPENDING = "org-appending", // 组织加入中
  REGISTER = "register", // 注册
  CREATE_ORGANIZATION = "create-organization", // 创建组织
  USER_INFO = "user-info", // 用户信息
  SET_PASSWORD = "set-password", // 设置密码
  SET_PHONE = "set-phone", // 设置手机号
}

/**
 * 登录步骤文案映射
 */
export const ShowTypeText: Record<ShowTypeEnum, string> = {
  [ShowTypeEnum.INIT]: "初始状态",
  [ShowTypeEnum.VERIFICATION]: "验证码输入",
  [ShowTypeEnum.PASSWORD]: "密码输入",
  [ShowTypeEnum.ORGANIZATION]: "组织选择",
  [ShowTypeEnum.NO_ORGANIZATION]: "无组织（创建/加入）",
  [ShowTypeEnum.JOIN_ORGANIZATION]: "加入组织",
  [ShowTypeEnum.INPUT_NAME]: "输入姓名",
  [ShowTypeEnum.ORG_APPENDING]: "组织加入中",
  [ShowTypeEnum.REGISTER]: "注册",
  [ShowTypeEnum.CREATE_ORGANIZATION]: "创建组织",
  [ShowTypeEnum.USER_INFO]: "用户信息",
  [ShowTypeEnum.SET_PASSWORD]: "设置密码",
  [ShowTypeEnum.SET_PHONE]: "设置手机号",
}

export type ShowType = `${ShowTypeEnum}`
